exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#loadingScreen{display:-webkit-box;display:-ms-flexbox;display:flex;flex-flow:column wrap;justify-content:center;align-items:center;position:fixed;top:0;right:0;bottom:0;left:0;z-index:100;background-color:rgba(0,0,0,.54);transform:translateZ(0);transition:all .5s cubic-bezier(.35,0,.25,1)}#loadingScreen .md-spinner{position:relative;z-index:1000;left:0}#loadingScreen .md-spinner .md-spinner-path{stroke:#15cabf}#loadingScreen .loading-text{position:relative;color:#fafafa!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a43e5832","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/loadingScreen.vue
// module id = 52
// module chunks = 0